import axios from './../plugins/private-api-axios'

export const liveNotificationService = {
    urlPrefix: '/liveNotifications',
    config: {
        headers: {
            Authorization: ''
        }
    },
    async subscribe (connectionId) {
        try {
            return await axios.post(`${this.urlPrefix}/subscribe?ConnectionId=${connectionId}`, {}, this.config)
        } catch (e) {
            throw e
        }
    },
    async keepAlive (connectionId) {
        try {
            return await axios.get(`${this.urlPrefix}/keepAlive/${connectionId}`, this.config)
        } catch (e) {
            throw e
        }
    }
}

export const updateLiveNotificationService = (accessToken) => {
    liveNotificationService.config.headers.Authorization = accessToken
}

export default liveNotificationService
